import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {IonicModule} from '@ionic/angular';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {DrawableImageFieldInputTypeHandlerComponent} from './drawable-image-field-input-type-handler.component';
import {ButtonModule} from '../../../../../../../../modules/core/component/button/button.module';
import {SelectFilterModule} from '../../../../../../select-filter/select-filter.module';
import {
    RadioButtonGroupInputModule
} from '../../../../../../radio-button-group/radio-button-group-input/radio-button-group-input.module';
import {MatRadioModule} from '@angular/material/radio';
import {NumberInputModule} from '../../../../../../number/number-input/number-input.module';
import {FormFieldModule} from '../../../../../../../../modules/core/component/form-field/form-field.module';
import {ColorPickerModule} from 'ngx-color-picker';
import {CheckboxInputModule} from '../../../../../../checkbox/checkbox-input/checkbox-input.module';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        IonicModule,
        ReactiveFormsModule,
        ButtonModule,
        SelectFilterModule,
        RadioButtonGroupInputModule,
        MatRadioModule,
        NumberInputModule,
        FormFieldModule,
        ColorPickerModule,
        CheckboxInputModule,
    ],
    declarations: [
        DrawableImageFieldInputTypeHandlerComponent,
    ],
    exports: [
        DrawableImageFieldInputTypeHandlerComponent,
    ],
})
export class DrawableImageFieldInputTypeHandlerModule {}
